export enum ELocale {
  EN = 'en',
  FI = 'fi',
  ES = 'es',
  SV = 'sv',
  NL = 'nl',
  DE = 'de',
  FR = 'fr',
  NO = 'no',
  DA = 'da',
  IT = 'it',
  ZH = 'zh',
  PL = 'pl',
  RU = 'ru',
  PT = 'pt',
  CS = 'cs',
  HI = 'hi',
  EL = 'el',
  MS = 'ms',
  SR = 'sr',
  KO = 'ko',
  JA = 'ja',
}

export const localeDataModules = {
  [ELocale.EN]: () =>
    import(/* webpackChunkName: "locale-en" */ 'react-intl/locale-data/en'),
  [ELocale.FI]: () =>
    import(/* webpackChunkName: "locale-fi" */ 'react-intl/locale-data/fi'),
  [ELocale.ES]: () =>
    import(/* webpackChunkName: "locale-es" */ 'react-intl/locale-data/es'),
  [ELocale.SV]: () =>
    import(/* webpackChunkName: "locale-sv" */ 'react-intl/locale-data/sv'),
  [ELocale.NL]: () =>
    import(/* webpackChunkName: "locale-nl" */ 'react-intl/locale-data/nl'),
  [ELocale.DE]: () =>
    import(/* webpackChunkName: "locale-de" */ 'react-intl/locale-data/de'),
  [ELocale.FR]: () =>
    import(/* webpackChunkName: "locale-fr" */ 'react-intl/locale-data/fr'),
  [ELocale.NO]: () =>
    import(/* webpackChunkName: "locale-no" */ 'react-intl/locale-data/no'),
  [ELocale.DA]: () =>
    import(/* webpackChunkName: "locale-da" */ 'react-intl/locale-data/da'),
  [ELocale.IT]: () =>
    import(/* webpackChunkName: "locale-it" */ 'react-intl/locale-data/it'),
  [ELocale.ZH]: () =>
    import(/* webpackChunkName: "locale-zh" */ 'react-intl/locale-data/zh'),
  [ELocale.PL]: () =>
    import(/* webpackChunkName: "locale-pl" */ 'react-intl/locale-data/pl'),
  [ELocale.RU]: () =>
    import(/* webpackChunkName: "locale-ru" */ 'react-intl/locale-data/ru'),
  [ELocale.PT]: () =>
    import(/* webpackChunkName: "locale-pt" */ 'react-intl/locale-data/pt'),
  [ELocale.CS]: () =>
    import(/* webpackChunkName: "locale-cs" */ 'react-intl/locale-data/cs'),
  [ELocale.HI]: () =>
    import(/* webpackChunkName: "locale-hi" */ 'react-intl/locale-data/hi'),
  [ELocale.EL]: () =>
    import(/* webpackChunkName: "locale-el" */ 'react-intl/locale-data/el'),
  [ELocale.MS]: () =>
    import(/* webpackChunkName: "locale-ms" */ 'react-intl/locale-data/ms'),
  [ELocale.SR]: () =>
    import(/* webpackChunkName: "locale-sr" */ 'react-intl/locale-data/sr'),
  [ELocale.KO]: () =>
    import(/* webpackChunkName: "locale-ko" */ 'react-intl/locale-data/ko'),
  [ELocale.JA]: () =>
    import(/* webpackChunkName: "locale-ja" */ 'react-intl/locale-data/ja'),
};

export const DEFAULT_LOCALE = ELocale.EN;

export const isValidLocale = (locale: string | null): locale is ELocale =>
  !!locale && Object.values(ELocale).indexOf(locale) !== -1;
